module.exports = __webpack_public_path__ + "USDOL_Seal.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/USDOL_Seal.png
// module id = 849
// module chunks = 0